module.exports = __webpack_public_path__ + "img/userImgDef.66a4923b.png";